import { renderRichText } from "@/components/common/rich-text";

const SECTIONS = [
  {
    title: "면책 고지",
    paragraphs: [
      "본 면책 고지는 본 약관의 일부를 구성하며, 이용자가 본 약관에 동의함으로써 그 효력이 발생합니다.",
      "이 플랫폼에 포함된 내용은 이용자의 관심사에 대한 일반적인 안내를 위한 것입니다. 이 플랫폼에서 제공되는 정보, 매칭·추천 결과, AI 솔루션 관련 자료는 전문적인 세금, 회계, 법률 또는 기술 도입에 관한 자문을 구성하지 아니하며, 이 플랫폼의 작성자 또는 발행자는 그에 관하여 책임을 지지 아니합니다.",
      "여기에서 제공되는 내용을 전문적인 컨설팅 서비스와 동등한 중요도를 가지고 취급해서는 안 되며, 이에 따른 어떠한 결정이나 행동을 하기 전에 반드시 프라이스워터하우스쿠퍼스컨설팅의 전문가와 상의하시기 바랍니다.",
      "회사는 이 플랫폼에 신뢰할 수 있는 근거를 바탕으로 한 내용을 담기 위하여 노력하고 있으나, 이용자가 이 플랫폼에서 정보를 얻어 행동함으로써 발생한 실수, 누락 등 모든 결과에 대하여 책임을 지지 아니합니다. 이 플랫폼에서 제공되는 모든 내용은 그 완성도, 정확도 또는 해당 정보의 사용으로 발생하는 결과에 대하여 어떠한 보증도 제공하지 아니합니다.",
      "이 플랫폼에서 공급사의 AI 솔루션, 외부 웹사이트 기타 제3자가 운영하는 자원으로 연결되는 경우, 회사는 해당 자원에 관한 권한이 없으며 그곳에서 제공되는 정보의 정확도나 그 밖의 요소에 관하여 이를 대변하지 아니합니다.",
    ],
  },
  {
    title: "제1조(목적 및 정의)",
    paragraphs: [
      "① 본 약관은 회사가 제공하는 플랫폼 서비스의 이용조건 및 절차, 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.\n② 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.\n1. <b>'플랫폼'</b>이란 회사가 AI 전환을 추진하는 수요기업과 검증된 AI 공급사를 연결하기 위하여 운영하는 양면형 AI 중개 서비스 및 이를 제공하는 웹사이트 일체를 말합니다.\n2. <b>'이용자'</b>란 본 약관에 동의하고 플랫폼에 회원으로 가입하여 회사가 제공하는 서비스를 이용하는 자를 말하며, 수요자·공급자·관리자 및 내부 이용자를 포함합니다.\n3. <b>'수요자(Demander)'</b>란 AI Agent 및 솔루션의 도입을 검토하기 위하여 플랫폼을 이용하는 기업 및 그 담당자를 말합니다.\n4. <b>'공급자(Provider)'</b>란 자사의 AI Agent 또는 솔루션 정보를 플랫폼에 등록하여 수요자와의 매칭을 희망하는 외부 AI 공급사를 말합니다.\n5. <b>'AI Agent 및 솔루션'</b>(이하 통칭하여 'AI 솔루션')이란 공급자가 플랫폼에 등록한 인공지능 기반 제품, 응용프로그램, 서비스 및 관련 정보 일체를 말합니다.\n6. <b>'매칭(Matching)'</b>이란 회사가 수요자의 요구사항을 분석하여 사전 검증된 공급자의 AI 솔루션을 추천·연결하는 행위를 말합니다.\n7. <b>'콘텐츠'</b>란 이용자가 플랫폼에 입력·등록한 요구사항 정보, 프로젝트 리포트, AI 솔루션 정보, 문의 티켓 및 기타 일체의 자료를 말합니다.\n③ 본 약관에서 정하지 아니한 용어의 의미는 관계 법령 및 일반적인 거래관행에 따릅니다.",
    ],
  },
  {
    title: "제2조(약관의 효력 및 변경)",
    paragraphs: [
      "① 본 약관은 플랫폼의 초기 화면 또는 회원가입 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.\n② 이용자가 회원가입 절차에서 본 약관에 동의함으로써 본 약관은 회사와 해당 이용자 간에 적용됩니다.\n③ 회사는 「약관의 규제에 관한 법률, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관계 법령을 위배하지 아니하는 범위에서 본 약관을 변경할 수 있습니다.\n④ 회사가 약관을 변경하는 경우에는 적용일자 및 변경사유를 명시하여 적용일자 7일 전부터 플랫폼을 통해 공지합니다. 다만, 이용자에게 불리한 변경의 경우에는 적용일자 30일 전부터 공지하고, 이용자가 등록한 전자우편 등의 방법으로 개별 통지합니다.\n⑤ 이용자가 변경된 약관의 적용일자 이후에도 서비스를 계속 이용하는 경우 변경된 약관에 동의한 것으로 봅니다. 변경된 약관에 동의하지 아니하는 이용자는 이용계약을 해지(회원 탈퇴)할 수 있습니다.",
    ],
  },
  {
    title: "제3조(서비스의 내용 및 회사의 지위)",
    paragraphs: [
      "① 회사는 플랫폼을 통하여 다음 각 호의 서비스를 제공합니다.\n1. 수요자의 니즈를 구조화하기 위한 대화형 진단 및 요구사항 정의 지원\n2. 사전 검증된 공급자의 AI 솔루션 풀(pool)에 기반한 매칭 및 추천\n3. 공급자의 AI 솔루션 정보 등록 및 노출\n4. 도입 결정 고객에 대한 PoC, 운영·통합, 비즈니스 확산 등 컨설팅 연계 지원\n5. 기타 회사가 정하는 부가 서비스\n② <b>회사는 수요자와 공급자 간의 거래를 중개·연결하는 플랫폼 사업자이며, AI 솔루션의 직접적인 공급자·판매자·제조자 또는 거래의 당사자가 아닙니다.</b> AI 솔루션에 관한 계약은 수요자와 공급자 간에 직접 체결되며, 회사는 해당 거래의 당사자가 되지 아니합니다.\n③ 회사가 수행하는 공급자 및 AI 솔루션에 대한 사전 검증은 회사가 정한 기준과 시점에 따라 합리적인 범위에서 이루어지는 절차로서, 해당 AI 솔루션의 품질, 성능, 정확성, 적법성, 특정 목적에의 적합성 또는 거래의 성사·성공을 보증하는 것이 아닙니다.\n④ 회사는 매칭·추천 결과를 정보 제공의 목적으로 제시하며, AI 솔루션의 도입 여부 및 도입에 따른 의사결정은 전적으로 이용자의 판단과 책임에 따릅니다.\n⑤ 회사는 운영상·기술상의 필요에 따라 제공하는 서비스의 전부 또는 일부를 변경·중단할 수 있으며, 이 경우 사전에 그 내용을 공지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.",
    ],
  },
  {
    title: "제4조(이용계약의 성립 및 회원가입)",
    paragraphs: [
      "① 이용계약은 이용자가 본 약관 및 개인정보처리방침의 내용에 동의하고, 회사가 정한 가입 양식에 따라 회원정보를 기입하여 가입을 신청한 후 회사가 이를 승낙함으로써 성립합니다.\n② 플랫폼은 마이크로소프트 Entra ID 기반의 B2B Guest 인증 방식으로 운영되며, 이용자는 회사가 발송한 초대메일을 통하여 회원가입을 신청하고 본인의 Entra ID로 인증합니다.\n③ 수요자는 회원가입 시 회사 이메일, 종사 분야(Industry), 도입을 희망하는 AI 종류 등 회사가 요청하는 정보를 제공하고 개인정보 수집·이용에 동의하여야 합니다.\n④ 회사는 다음 각 호에 해당하는 가입신청에 대하여는 승낙을 하지 아니하거나 사후에 이용계약을 해지할 수 있습니다.\n1. 타인의 명의 또는 정보를 이용하거나 허위의 정보를 기재한 경우\n2. 회원가입 요건을 충족하지 못하거나 회사가 요청하는 인증 절차를 완료하지 아니한 경우\n3. 관계 법령을 위반하거나 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우\n4. 회사의 정상적인 서비스 제공을 저해하거나 타 이용자에게 피해를 줄 우려가 있는 경우\n⑤ 회사는 서비스 운영상 또는 기술상 지장이 있는 경우 승낙을 유보할 수 있으며, 그 사유가 해소되는 즉시 가입신청을 처리합니다.",
    ],
  },
  {
    title: "제5조(회원정보의 변경 및 관리)",
    paragraphs: [
      "① 이용자는 회원정보에 변경이 있는 경우 지체 없이 이를 수정하여야 하며, 변경하지 아니하여 발생하는 불이익에 대하여 회사는 책임을 지지 아니합니다.\n② 이용자는 자신의 계정 및 인증수단을 선량한 관리자의 주의로 관리하여야 하며, 이를 제3자에게 양도·대여하거나 공유할 수 없습니다.\n③ 이용자는 자신의 계정이 부정하게 사용되거나 보안상 문제가 발생한 사실을 인지한 경우 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.",
    ],
  },
  {
    title: "제6조(이용자의 의무)",
    paragraphs: [
      "① 이용자는 다음 각 호의 행위를 하여서는 아니 됩니다.\n1. 가입신청 또는 정보 변경 시 허위 내용을 등록하는 행위\n2. 타인의 정보를 도용하거나 회사에 게시된 정보를 무단으로 변경하는 행위\n3. 회사 또는 제3자의 지식재산권, 영업비밀 기타 권리를 침해하는 행위\n4. 회사의 사전 승낙 없이 플랫폼을 영리 목적으로 이용하거나, 플랫폼에서 취득한 정보를 본래의 이용 목적 외로 복제·배포·가공·제공하는 행위\n5. 회사의 동의 없이 자동화된 수단(크롤러, 스크래퍼 등)을 이용하여 플랫폼의 정보를 수집하는 행위\n6. 악성코드의 유포, 해킹, 비정상적인 접근 등 플랫폼의 안정적 운영을 방해하는 행위\n7. 음란·폭력적·차별적 내용 기타 공서양속에 반하는 정보를 게시하는 행위\n8. 기타 관계 법령 또는 본 약관에 위반되는 행위\n② 공급자는 플랫폼에 등록하는 AI 솔루션 정보가 사실에 부합하고 관계 법령 및 제3자의 권리를 침해하지 아니함을 보장하며, 등록 정보의 정확성·적법성에 대한 책임을 부담합니다.\n③ 이용자가 본조의 의무를 위반하여 회사 또는 제3자에게 손해를 발생시킨 경우, 해당 이용자는 그 손해를 배상할 책임이 있습니다.",
    ],
  },
  {
    title: "제7조(콘텐츠의 권리 및 이용허락)",
    paragraphs: [
      "① 이용자가 플랫폼에 입력·등록한 콘텐츠에 대한 권리는 해당 이용자 또는 정당한 권리자에게 귀속됩니다.\n② 이용자는 회사가 서비스의 운영, 매칭, 개선 및 관련 컨설팅 연계를 위하여 필요한 범위에서 해당 콘텐츠를 이용(저장, 복제, 분석, 가공, 표시 등)할 수 있도록 허락합니다. 회사는 이를 본래의 서비스 제공 목적 범위를 벗어나 이용하지 아니합니다.\n③ 회사가 플랫폼을 통하여 제공하는 정보, 자료, 매칭 결과 보고서, 디자인 및 소프트웨어 등 일체의 저작물에 대한 지식재산권은 회사에 귀속되며, 이용자는 회사의 사전 서면 동의 없이 이를 복제·배포·전송·출판할 수 없습니다.",
    ],
  },
  {
    title: "제8조(개인정보의 보호)",
    paragraphs: [
      "① 회사는 관계 법령이 정하는 바에 따라 이용자의 개인정보를 보호하기 위하여 노력합니다.\n② 개인정보의 수집·이용·보관·파기 및 제3자 제공 등에 관한 구체적인 사항은 회사가 별도로 정하여 플랫폼에 게시하는 개인정보처리방침에 따릅니다.",
    ],
  },
  {
    title: "제9조(면책조항)",
    paragraphs: [
      "<b>회사는 수요자와 공급자를 연결하는 중개 플랫폼 사업자로서, 다음 각 항에 대하여 책임을 부담하지 아니합니다. 다만, 회사의 고의 또는 중대한 과실로 인한 경우에는 그러하지 아니합니다.</b>\n① <b>AI 솔루션 자체에 관한 면책.</b> 회사는 공급자가 등록·제공하는 AI 솔루션의 품질, 성능, 정확성, 신뢰성, 완전성, 최신성, 특정 목적에의 적합성 및 적법성을 보증하지 아니하며, 해당 AI 솔루션의 하자, 오류, 오작동, 산출물의 부정확성 또는 그로 인하여 이용자에게 발생한 손해에 대하여 책임을 지지 아니합니다.\n② <b>공급자의 신뢰성에 관한 면책.</b> 회사가 수행하는 공급자에 대한 사전 검증은 회사가 정한 기준과 시점에 따른 합리적 범위의 절차로서, 공급자의 재무건전성, 사업 지속성, 계약 이행능력, 법령 준수 여부 또는 향후의 행위를 보증하지 아니합니다. 회사는 공급자의 부도, 폐업, 계약 불이행, 위법행위 기타 공급자에게 귀책사유가 있는 사정으로 이용자에게 발생한 손해에 대하여 책임을 지지 아니합니다.\n③ <b>거래에 관한 면책.</b> 수요자와 공급자 간에 직접 체결·이행되는 AI 솔루션 도입계약 및 그에 부수하는 일체의 거래에 관하여, 회사는 거래의 당사자가 아니므로 거래의 성사 여부, 계약조건, 대금의 지급, 납품, 하자담보, 분쟁의 해결 등에 대하여 책임을 지지 아니합니다.\n④ <b>매칭 결과에 관한 면책.</b> 회사가 제공하는 매칭·추천 결과는 정보 제공을 목적으로 하며 특정 AI 솔루션의 채택을 권유하거나 그 성과를 보증하는 것이 아닙니다. AI 솔루션의 도입 여부 및 그에 따른 결과는 전적으로 이용자의 판단과 책임에 따르며, 회사는 이용자의 의사결정 및 그 결과에 대하여 책임을 지지 아니합니다.\n⑤ <b>제3자 제공 정보에 관한 면책.</b> 회사는 공급자 기타 제3자가 제공한 정보를 그대로 게시·전달하는 경우 해당 정보의 진실성·정확성에 대하여 보증하지 아니하며, 이용자가 플랫폼에 게시·등록한 콘텐츠의 내용에 대하여도 책임을 지지 아니합니다.\n⑥ <b>정보의 성격에 관한 면책.</b> 이 플랫폼에 포함된 내용은 일반적인 안내를 위한 것으로서 전문적인 세금·회계·법률 또는 기술 도입에 관한 자문을 구성하지 아니합니다. 이용자는 이 플랫폼의 내용을 전문적인 컨설팅 서비스와 동등하게 취급하여서는 아니 되며, 이에 근거한 의사결정에 앞서 회사의 전문가와 상의하여야 합니다. 회사는 이 플랫폼에서 제공되는 내용의 완성도·정확도 또는 그 사용으로 발생하는 결과에 대하여 어떠한 보증도 제공하지 아니합니다.\n⑦ <b>외부 링크에 관한 면책.</b> 이 플랫폼에서 공급자의 AI 솔루션, 외부 웹사이트 기타 제3자가 운영하는 자원으로 연결되는 경우, 회사는 해당 자원에 관한 권한이 없으며 그곳에서 제공되는 정보의 정확도나 그 밖의 요소를 대변하지 아니하고, 이에 대하여 책임을 지지 아니합니다.\n⑧ <b>서비스 제공에 관한 면책.</b> 회사는 천재지변, 전쟁, 정전, 통신망의 장애, 해킹, 디도스(DDoS) 공격, 제3자가 제공하는 클라우드·LLM 등 외부 서비스의 장애 등 회사의 합리적인 통제범위를 벗어난 사유로 서비스를 제공할 수 없는 경우 그에 대한 책임을 지지 아니합니다.\n⑨ <b>이용자 귀책에 관한 면책.</b> 회사는 이용자의 귀책사유로 인한 서비스 이용의 장애, 이용자가 자신의 계정·인증수단을 소홀히 관리하여 발생한 손해, 이용자가 본 약관 또는 관계 법령을 위반하여 발생한 손해에 대하여 책임을 지지 아니합니다.\n⑩ <b>책임의 제한.</b> 회사가 이용자에게 손해배상책임을 부담하는 경우에도, 관련 법령에서 허용하는 최대 한도에서 회사의 책임은 통상의 직접 손해에 한하며, 특별손해, 간접손해, 일실이익(逸失利益), 데이터의 멸실로 인한 손해 등에 대하여는 회사가 그 발생을 알았거나 알 수 있었던 경우를 제외하고는 책임을 지지 아니합니다.\n⑪ 회사는 무료로 제공하는 서비스의 이용과 관련하여, 관계 법령에 특별한 규정이 없는 한 책임을 지지 아니합니다.",
    ],
  },
  {
    title: "제10조(손해배상)",
    paragraphs: [
      "① 이용자가 본 약관을 위반하거나 위법행위로 인하여 회사에 손해를 입힌 경우, 해당 이용자는 회사에 그 손해를 배상하여야 합니다.\n② 이용자가 플랫폼을 이용하는 과정에서 또는 본 약관 위반으로 인하여 제3자로부터 회사가 손해배상 청구 등의 이의제기를 받은 경우, 해당 이용자는 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 그로 인하여 발생한 손해를 배상하여야 합니다.",
    ],
  },
  {
    title: "제11조(이용제한 및 이용계약의 해지)",
    paragraphs: [
      "① 회사는 이용자가 본 약관 또는 관계 법령을 위반하는 경우 사전 통지 후 서비스 이용의 제한, 계정의 정지 또는 이용계약의 해지 등의 조치를 할 수 있습니다. 다만, 위반의 정도가 중대하거나 긴급한 조치가 필요한 경우 사전 통지를 생략할 수 있습니다.\n② 이용자는 언제든지 회사가 정한 절차에 따라 이용계약의 해지(회원 탈퇴)를 신청할 수 있으며, 회사는 관계 법령이 정하는 바에 따라 이를 처리합니다.\n③ 이용계약이 해지되는 경우 이용자의 개인정보 및 콘텐츠는 개인정보처리방침 및 관계 법령에서 정한 바에 따라 처리됩니다.",
    ],
  },
  {
    title: "제12조(준거법 및 재판관할)",
    paragraphs: [
      "① 본 약관 및 회사와 이용자 간의 분쟁에는 대한민국 법령을 준거법으로 합니다.\n② 회사와 이용자 간에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원을 제1심 관할법원으로 합니다.",
    ],
  },
  {
    title: "부칙",
    paragraphs: ["본 약관은 2025년 6월 17일부터 시행합니다."],
  },
];

export const TermsPage = () => {
  return (
    <div className="px-5 py-10 lg:px-[100px] lg:py-10 flex flex-col gap-6 lg:gap-12 lg:max-w-[1240px] mx-auto">
      <div className="flex flex-col gap-2 lg:gap-3">
        <h1 className="text-[44px] leading-[48px] tracking-[-0.03em] lg:text-[56px] lg:leading-[64px] lg:tracking-[-0.03em] text-black text-center">
          AI Agent Connect 서비스 이용약관
        </h1>
        <span className="text-base leading-6 tracking-[-0.01em] text-black text-center">
          프라이스워터하우스쿠퍼스컨설팅
        </span>
      </div>

      <p className="text-base leading-6 tracking-[-0.01em] text-black">
        본 약관은 프라이스워터하우스쿠퍼스컨설팅(이하 &lsquo;회사&rsquo;)이 운영하는 AI Agent
        Connect 플랫폼(이하 &lsquo;플랫폼&rsquo;)의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및
        책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
      </p>

      <div className="flex flex-col gap-6">
        {SECTIONS.map((section) => (
          <div key={section.title} className="flex flex-col gap-3">
            <h2 className="text-2xl leading-7 lg:leading-8 tracking-[-0.02em] font-bold text-black">
              {section.title}
            </h2>
            {section.paragraphs.map((paragraph, pIdx) => (
              <ul key={pIdx} className="flex flex-col gap-2">
                {paragraph.split("\n").map((line, lIdx) => (
                  <li key={lIdx} className="text-base leading-6 tracking-[-0.01em] text-black">
                    {renderRichText(line)}
                  </li>
                ))}
              </ul>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
